<i18n>
{
  "fr": {
    "Title": "Rapport d'anomalies de tout le monde",
    "DisplayName": "Nom",
    "BugsCount": "Nombre d'anomalies causées",
    "Ratio": "Ratio",
    "TotalHours": "Nombre d'heures travaillées"
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title')" />
    <AppContainer>
      <table class="table table-bordered table-hover">
        <thead class="thead-dark">
          <tr>
            <th
              v-t="'DisplayName'"
              scope="col"/>
            <th
              v-t="'BugsCount'"
              scope="col"/>
            <th
              v-t="'TotalHours'"
              scope="col"/>
            <th
              v-t="'Ratio'"
              scope="col"/>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in usersBugs"
            :key="user.userId">
            <td>{{ user.displayName }}</td>
            <td>{{ user.bugsCount }}</td>
            <td>{{ user.totalHours }}</td>
            <td>{{ user.bugsCount / user.totalHours | percentage }}</td>
          </tr>
        </tbody>
      </table>
    </AppContainer>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('bugs', ['usersBugs']),
  },
  created() {
    this.$store.dispatch('bugs/getAllBugs', this.$route.query);
  },
};
</script>
